export const SET_NUMBER = 'SET_NUMBER'
export const RESET_NUMBER = 'RESET_NUMBER'
export const SET_BARRED_NUMBERS = 'SET_BARRED_NUMBERS'
export const RESET_BARRED_NUMBERS = 'RESET_BARRED_NUMBERS'
